import { connect } from "react-redux";
import AppSuperBar from './AppSuperBar';
import { userLogOut } from '../../redux/actions/auth'

const mapStatetoProps = state => {
  return {
    user: state.user
  };
};

const mapDispatchToProps = dispatch => {
  return {
    userLogOut: () => {    
      dispatch(userLogOut());
    }
  };
};
export default connect(
    mapStatetoProps,
    mapDispatchToProps
  )(AppSuperBar);
  